import PropTypes from 'prop-types';
// components
import MainLayout from './main';
import DefaultLayout from './DefaultLayout';
import NavLayout from './nav';

// ----------------------------------------------------------------------

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['main', 'default', 'nav']),
};

export default function Layout({ variant = 'default', children }) {

  if (variant === 'main') {
    return <MainLayout> {children} </MainLayout>;
  }
  if (variant === "nav") {
    return <NavLayout> {children} </NavLayout>;
  }
  return <DefaultLayout> {children} </DefaultLayout>;
}
